import { Tooltip, Typography } from '@mui/material';
import { ComponentProps, FC } from 'react';

interface Props extends ComponentProps<typeof Typography> {
  text: string;
  maxCharacters: number;
}

const TruncatedText: FC<Props> = ({ text, maxCharacters, ...props }) => {
  return text.length > maxCharacters ? (
    <Tooltip title={text} data-testid="tooltip">
      <span>
        <Typography {...props}>{`${text
          .substring(0, maxCharacters)
          .trim()}...`}</Typography>
      </span>
    </Tooltip>
  ) : (
    <Typography {...props}>{text}</Typography>
  );
};

export default TruncatedText;
